import { render, staticRenderFns } from "./OrderItemArchived.vue?vue&type=template&id=4642214a&scoped=true&"
import script from "./OrderItemArchived.vue?vue&type=script&lang=js&"
export * from "./OrderItemArchived.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemArchived.vue?vue&type=style&index=0&id=4642214a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642214a",
  null
  
)

export default component.exports